module.exports = {
	"id": "EC",
	"name": "Ecuador",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.020463,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.020463,
			"19": null,
			"20": null,
			"21": 0.006821,
			"22": 0.163704,
			"23": 0.013642,
			"24": null,
			"25": 0.013642,
			"26": 0.054568,
			"27": 0.020463,
			"28": null,
			"29": 0.020463,
			"30": 0.013642,
			"31": 0.034105,
			"32": 0.020463,
			"33": 0.020463,
			"34": 0.040926,
			"35": 0.027284,
			"36": 0.040926,
			"37": 0.040926,
			"38": 0.047747,
			"39": 0.081852,
			"40": 0.047747,
			"41": 0.040926,
			"42": 0.047747,
			"43": 0.190988,
			"44": 0.102315,
			"45": 0.102315,
			"46": 0.102315,
			"47": 0.163704,
			"48": 0.13642,
			"49": 1.889417,
			"50": 0.218272,
			"51": 0.627532,
			"52": 0.716205,
			"53": 32.577096,
			"54": 9.801777,
			"55": 0.122778,
			"56": 0.020463,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013642,
			"12": 0.013642,
			"13": null,
			"14": 0.013642,
			"15": null,
			"16": 0.013642,
			"17": 0.013642,
			"18": null,
			"19": 0.006821,
			"20": 0.013642,
			"21": 0.013642,
			"22": 0.006821,
			"23": 0.006821,
			"24": 0.006821,
			"25": 0.013642,
			"26": 0.006821,
			"27": 0.006821,
			"28": 0.020463,
			"29": 0.034105,
			"30": 0.020463,
			"31": 0.034105,
			"32": 0.027284,
			"33": 0.054568,
			"34": 0.054568,
			"35": 0.061389,
			"36": 0.047747,
			"37": 0.081852,
			"38": 0.095494,
			"39": 0.075031,
			"40": 0.075031,
			"41": 0.081852,
			"42": 0.075031,
			"43": 0.334229,
			"44": 0.109136,
			"45": 0.190988,
			"46": 0.143241,
			"47": 0.852625,
			"48": 0.893551,
			"49": 8.471682,
			"50": 0.109136,
			"51": 0.013642,
			"52": null,
			"3.5": null,
			"3.6": 0.013642
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.020463,
			"37": 0.020463,
			"38": 0.034105,
			"39": 0.020463,
			"40": 0.511575,
			"41": 0.088673,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.006821
		},
		"safari": {
			"0": null,
			"4": 0.006821,
			"5": 0.020463,
			"6": 0.013642,
			"7": 0.047747,
			"8": 0.252377,
			"9": 0.20463,
			"10": 0.975403,
			"3.1": null,
			"3.2": null,
			"5.1": 0.040926,
			"6.1": 0.020463,
			"7.1": 0.013642,
			"9.1": 0.838983
		},
		"ios_saf": {
			"8": 0,
			"10": 1.87108634388,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0504236118859,
			"8.1-8.4": 0.0931554863655,
			"9.0-9.2": 0.0444411494588,
			"9.3": 0.67801240841
		},
		"android": {
			"3": 0,
			"4": 0.0639989379845,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00799986724806,
			"4.1": 0.230853312016,
			"4.2-4.3": 0.577133280039,
			"4.4": 1.32340661047,
			"4.4.3-4.4.4": 1.33483499225
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.168426230769,
			"9": 0.0842131153846,
			"10": 0.133337432692,
			"11": 1.07371722115,
			"5.5": null
		},
		"op_mob": {
			"0": 0.1229892918,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00341636921667
		},
		"edge": {
			"12": 0.075031,
			"13": 0.238735,
			"14": 0.395618
		},
		"ie_mob": {
			"10": 0.224410535211,
			"11": 0.913671464789
		},
		"bb": {
			"7": 0.06437475,
			"10": null
		},
		"samsung": {
			"0": 3.334771
		},
		"and_uc": {
			"0": 0.359227
		},
		"op_mini": {
			"0": 1.65701333898
		},
		"and_chr": {
			"0": 20.595087
		},
		"and_ff": {
			"0": 0.015895
		}
	},
	"total": 98.60443675
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/EC.json
 ** module id = 512
 ** module chunks = 0
 **/